export const removeItemRecipe =
  <T, K extends keyof T>(key: K, value: T[K]) =>
  (draft: T[]): T[] => {
    const index = draft?.findIndex((item) => item[key] === value) ?? -1;
    if (index > -1) {
      draft.splice(index, 1);
    }
    return draft;
  };
